const initialState = {
  productlist: [],
  errorMessages: {}
};

const productReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'LIST_PRODUCTS':
      return {
        ...state, productlist: action.payload
      }
    default:
      return state
  }
}

export default productReducer;